import { RightOutlined } from '@ant-design/icons';
import { List, Skeleton } from 'antd'
import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { notificationlist, updatenotificationcount, updatenotificationneworold, updatenotificationread, updatenotificationreadall } from '../../../store/Common/CommonSlice';
import { Link } from 'react-router-dom';
import { savequeryid } from '../../../store/Queries/QueriesSlice';
import { authuser } from '../../../store/Authentication/AuthSlice';

const NotificationsList = ({notificationData,count,setOpen,open}) => {
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState([]);
    const [newCount, setNewCount] = useState(count);
    const dispatch = useDispatch();
    const loginedUser = useSelector(authuser);

    const onLoadMore = () => {
        setLoading(true);
        let countvalue = count + newCount;
        setNewCount(countvalue)
        dispatch(notificationlist(countvalue))
        .then((res)=>{
            if(res?.payload?.data?.statusCode === 200){
                const newData = res?.payload?.data?.data;
                console.log(newData,"newData")
                setList(newData);
            //     console.log(res?.payload?.data.newCount,"count");
            //     let newcountval=res?.payload?.data?.newCount
            //     if (newcountval > 0) {
            //       const audio = new Audio('public/mixkit-correct-answer-tone-2870.wav');
            //       audio.play().catch(err => console.error('Audio playback failed:', err));
            //   }
                setLoading(false);
            }
        })
        .catch(err=>{
            console.error(err);
        })
    };
    const readAll = () =>{
        setOpen(false);
        dispatch(updatenotificationreadall())
    }
    const handleClose = (id,queryId) => {
        if(id){
            dispatch(updatenotificationread(id))
        }
        if(queryId){
            dispatch(savequeryid(queryId))
        }
        setOpen(false);
    };
    const loadMore = <>
                        <hr className='border-[#F5F5F5] my-2'/>
                        <div className="flex p-5 gap-5 items-center justify-center flex-wrap">
                            {
                                (newCount < notificationData?.notificationCount) &&
                                    <button type="button" onClick={onLoadMore} className="btn btn_54">
                                        <span>Load More</span>
                                    </button>
                            }
                            {
                                list.length > 0 &&
                                <button type="button" onClick={readAll} className="btn btn_54">
                                    <span>Mark all as read</span>
                                </button>
                            }
                        </div>
                    </>
    useEffect(()=>{
        if(open){
            setLoading(true);
            dispatch(notificationlist(count))
            .then((res)=>{
                console.log(res,"notification list");
                setLoading(false);
                if(res?.payload?.data?.statusCode === 200){
                    setList(res?.payload?.data?.data)
                   // dispatch(updatenotificationneworold())
                }
            })
            .catch(err=>{
                console.error(err);
            })
        }
    },[open])

      const ReadNotification = ( item) => {
          dispatch(updatenotificationread(item._id)).then((res) => {
            if (res?.payload?.data?.statusCode === 200) {
              const newData = res?.payload?.data?.data;
              setList(newData);
            dispatch(updatenotificationcount(res?.payload?.data?.newCount))
            setOpen(false);
            }
            })

      }

    // This common NotificationsList is shared by customer, customer_admin and
    // kam (only air_admin uses the separate Admin AppDrawer), so the booking /
    // quote destinations differ by role.
    const userRole = loginedUser?.userroles;
    const isKam = userRole === "kam";

    // Resolve the in-app destination for a notification based on its type/role.
    // Keep this in sync with the backend `notification_type` values (the same
    // set the admin AppDrawer handles). Returning '' means "no destination".
    const getNotificationLink = (item) => {
        const queryId = item?.queryId;
        const bookingId = item?.redirect_id || item?.queryId;
        switch (item?.notification_type) {
            case "Quote":
            case "ManualQuote":
                return isKam
                    ? `/QueriesKAM?queryId=${queryId}&quoteType=${item?.notification_type}`
                    : `/queries?queryId=${queryId}&quoteType=${item?.notification_type}`;
            // All booking lifecycle events land on the same booking-detail page.
            // Backend notification_type values: "Booking Confirmation" (confirmed),
            // "Confirmation Awaited" (awaiting carrier), "Booking Update" (updated),
            // "Booking Cancellation" (cancelled); "Booking" kept for back-compat.
            case "Booking":
            case "Booking Confirmation":
            case "Confirmation Awaited":
            case "Booking Update":
            case "Booking Cancellation":
                if (isKam) {
                    // Air: same standalone detail page the customer gets, and the
                    // same one a KAM's own eye icon on the Queries list now opens
                    // for Booking Confirmed / Confirmation Awaited / Booking
                    // Cancelled (see handleAirBookingView in pages/Admin/Queries.jsx).
                    // It used to drop the KAM on /QueriesKAM?quoteType=..., which
                    // rendered the inline query form instead of the booking.
                    // `from=queries` sends the page's back button to /QueriesKAM.
                    // Ocean falls through to the shared link below — the same
                    // standalone page a KAM's ocean eye now opens too (see
                    // handleOceanBookingView). It is read-only: only the Queries
                    // "Assign MBL" button passes `&assign=1` to jump into the
                    // confirm flow, so a Confirmation Awaited notification lands
                    // on the page's "Assign Tracking Number" banner instead.
                    if (item?.carrier_type !== 'Ocean Cargo') {
                        return `/booking-history/air-booking-details?queryId=${bookingId}&from=queries`;
                    }
                    // return `/QueriesKAM?queryId=${bookingId}&quoteType=${item?.notification_type}`;
                }
                // Customer / customer_admin booking detail pages. Both ocean and
                // air details read the queryId from the URL param below (redux,
                // seeded via savequeryid on click, remains a fallback).
                return item?.carrier_type === 'Ocean Cargo'
                    ? `/booking-history/ocean-cargo-booking-details?queryId=${bookingId}`
                    : `/booking-history/air-booking-details?queryId=${bookingId}`;
            case "Payment":
                // Same two destinations as the booking cases above. Air used to
                // point at /booking-history/air-cargo-booking-details, a second,
                // older air detail surface — so a Payment notification and a
                // Booking notification for the same booking opened two visually
                // different pages. Both now land on the unified detail page.
                // queryId is passed explicitly rather than relying on the redux
                // id handleNotificationClick seeds, so the link also works on a
                // refresh or when opened cold.
                if (item?.carrier_type === 'Air Cargo') {
                    return `/booking-history/air-booking-details?queryId=${bookingId}`;
                }
                if (item?.carrier_type === 'Ocean Cargo') {
                    return `/booking-history/ocean-cargo-booking-details?queryId=${bookingId}`;
                }
                return '';
            case "KYC":
                return '/user/kyc';
            case "Credit":
                return '/user/my-credits';
            default:
                return '';
        }
    };

    // Marks the notification read/closes the drawer, and seeds the selected
    // queryId in redux so booking-detail pages that read it from the store
    // (e.g. ocean-cargo-booking-details) load the right booking.
    const handleNotificationClick = (item) => {
        const bookingId = item?.redirect_id || item?.queryId;
        if (bookingId) {
            dispatch(savequeryid(bookingId));
        }
        ReadNotification(item);
    };

    return (
        <List className={loading ? 'p-5 my-5' : 'w-full'}
            itemLayout="horizontal"
            dataSource={list}
            loadMore={loadMore}
            renderItem={(item, index) => (
                <Skeleton active loading={loading}>
                    <Link  className={`notinew ${item?.reading_status === "unread" ? "unreadMsg" :"readMsg"}`}  to={getNotificationLink(item)} onClick={()=>handleNotificationClick(item)}>
                        <List.Item className={`hover:bg-[#F7F5FF] cursor-pointer flwx gap-2 break-word ${item.reading_status === 'read' ? 'bg-white' : 'bg-bgbox' }`}>
                            <List.Item.Meta
                            title={item.message}
                            />
                            <RightOutlined />
                        </List.Item> 
                    </Link>
                </Skeleton>
            )}
        />
    )
}

export default React.memo(NotificationsList)